const { render } = wp.element;

import QuoteCalculator from "./app/QuoteCalculator";

const quoteCalculators = document.querySelectorAll('.wp-block-mof-quote-calculator, [data-company]');
quoteCalculators.forEach(quoteCalculator => {
	try {
		if (quoteCalculator.dataset.mofQuoteCalculatorMounted) return;

		const company = quoteCalculator.dataset.company
		const agent = quoteCalculator.dataset.agent
		if (!quoteCalculator.classList.contains('wp-block-mof-quote-calculator') && !company) return;

		quoteCalculator.dataset.mofQuoteCalculatorMounted = 'true';
		quoteCalculator.classList.add('wp-block-mof-quote-calculator');

		render(<QuoteCalculator company={company} agent={agent} />, quoteCalculator);
	} catch (error) {
		delete quoteCalculator.dataset.mofQuoteCalculatorMounted;
		console.error('Failed to mount Monera quote calculator.', error);
	}
});

document.addEventListener('click', (e) => {
	const { target } = e;
	if (!target.classList.contains('btn-primary')) return;

	const header = 1024 <= window.innerWidth ? document.querySelector('.mh__primary-row') : document.querySelector('.mh');
	const maincontent = document.getElementById('maincontent');

	if (!header || !maincontent) return;

	let offset = header.clientHeight
	let position = Math.ceil(window.pageYOffset + maincontent.getBoundingClientRect().top - offset);
	window.scrollTo(0, position);
});



// WEBPACK FOOTER //
// blocks/quote-calculator/frontend.js